module.exports = __webpack_public_path__ + "img/nb-2.ebc7125b.png";